import React, {Component} from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import URL from 'url-parse';

import KeyboardListener from '~/src/components/listener/keyboard/KeyboardListener';
import Image from '~/src/components/image/Image';
import HtmlText from '~/src/components/htmlText/HtmlText';
import FacebookShare from '~/src/components/share/facebook/FacebookShare';
import EmailShare from '~/src/components/share/email/EmailShare';
import CopyShare from '~/src/components/share/copy/CopyShare';
import WhatsAppShare from '~/src/components/share/whatsApp/WhatsAppShare';
import CloseX from '~/src/components/svg/action/CloseX';
import MainLogo from '~/src/components/svg/navigation/MainLogo';

import {getFeedUrl} from '~/src/utilities/helpers/feed.js';
import {getJsonRequest} from '~/src/utilities/helpers/request.js';
import {getContentUrl} from '~/src/utilities/helpers/link.js';
import {ImageFormat} from '~/src/utilities/constants/formats.js';
import initPolyglot from '~/src/utilities/libs/polyglot';
import {Logger} from '~/src/utilities/helpers/log';

import css from './ShareModal.module.scss';
import i18nStrings from './ShareModal.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class ShareModal extends Component {
    state = {
        title: '',
        lead: '',
        image: null,
        url: ''
    };

    componentDidMount() {
        if (this.props.closeActionBubble) {
            this.props.closeActionBubble();
        }

        getJsonRequest(getFeedUrl('content', {metadataId: this.props.metadataId}))
            .then((data) => {
                const meta = get(data, 'content.meta');

                this.setState({
                    titleHeader: get(meta, 'teaser.default.titleHeader'),
                    title: get(meta, 'teaser.default.title'),
                    lead: get(meta, 'teaser.default.lead'),
                    image: get(meta, 'teaser.default.image'),
                    url: new URL(getContentUrl(meta.url)).href
                });
            })
            .catch((error) => {
                Logger.info(`[${error.name}][ShareModal] error while fetching content feed`, {error, metadataId: this.props.metadataId});
            });
    }

    render() {
        return (
            <div className={css.shareModalContainer} data-testid="ShareModal">
                <div className={css.shareModalInnerContainer}>
                    <div className={css.shareModal}>
                        <div className={css.closeButton} data-testid="shareModalClose" onClick={this.props.onClose}>
                            <CloseX title={getTranslation('close')} />
                        </div>
                        <div className={css.storyInfo}>
                            <div className={css.storyLogo}>
                                <MainLogo />
                            </div>
                            <div className={css.storyImage}>
                                {this.state.image && <Image {...this.state.image} format={ImageFormat.IMAGE_COVER} lazyLoading={false} />}
                            </div>
                            <div className={css.storyTitleHeader}>
                                <HtmlText htmlText={this.state.titleHeader} />
                            </div>
                            <div className={css.storyTitle}>
                                <HtmlText htmlText={this.state.title} />
                            </div>
                        </div>
                        <div className={css.shareItemContainer}>
                            <div className={css.shareItemInnerContainer}>
                                <div className={css.shareItem}>
                                    <WhatsAppShare url={this.state.url} metadataId={this.props.metadataId} title={this.state.title} lead={this.state.lead} />
                                </div>
                                <div className={css.shareItem}>
                                    <FacebookShare url={this.state.url} metadataId={this.props.metadataId} title={this.state.title} lead={this.state.lead} />
                                </div>
                                <div className={css.shareItem}>
                                    <EmailShare url={this.state.url} metadataId={this.props.metadataId} title={this.state.title} lead={this.state.lead} />
                                </div>
                                <div className={css.shareItem}>
                                    <CopyShare url={this.state.url} metadataId={this.props.metadataId} title={this.state.title} lead={this.state.lead} />
                                </div>
                                <div className={css.shareItemClose} onClick={this.props.onClose}>
                                    {getTranslation('close')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <KeyboardListener onEsc={this.props.onClose} />
            </div>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    ShareModal.propTypes = {
        onClose: PropTypes.func.isRequired,
        closeActionBubble: PropTypes.func,
        metadataId: PropTypes.string.isRequired
    };
}

export default ShareModal;
